// import * as http from '../require'
import http from '../require'
export const lunboPage = data => http.post('/v1/health/web/news/lunbo_page', data)
export const noticePage = data => http.post('/v1/health/web/news/notice_page', data)
export const policyPage = data => http.post('/v1/health/web/news/policy_page', data)
export const resourcePage = data => http.post('/v1/health/web/news/resource_page', data)
export const securityPage = data => http.post('/v1/health/web/news/security_page', data)
export const newsDetail = id => http.get(`/v1/health/web/news/${id}/detail`)
export const healthFakeData = data => http.get('/v1/health/web/student_health/fake_data', data)
